import { Component, Fragment, forwardRef } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { CircularProgress, Grid, Box } from '@mui/material';
import { connect } from 'react-redux';

//kendo
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

//icons

//constants
import { FACILITIES_VIEW_TYPE, INSTRUCTOR_TIMETABLE, ROOM_TIMETABLE, SET_TIMETABLE, ACADEMIC_VIEW_TYPE, accountTypes, CENTRAL_TIMETABLER_VIEW_TYPE } from '../../constants';
import { MOMENT_DATE_FORMAT, MOMENT_TIME_DISPLAY_FORMAT } from '../../constants/date_format';
import { colors } from '../../theme';
import './timetable.css';

//apis
import TermApi from '../../api/term.api';

//services
import {
    exportDepartmentInstructorReport,
    exportDepartmentSetReport,
    exportMultipleInstructorReport,
    exportMultipleRoomReport,
    exportMultipleSetReport,
} from '../../services/timetable/ssrsReportService';
import TimetableApi from '../../api/timetable/timetable.api';

//comps
import Timetable from './timetable';
import Button from '../../components/global/button';
import { AppBarState } from '../../components/layout/mainLayout';
import PrintMultipleReports from '../../components/form-components/popupEditors/printMultipleDialog';
import GlobalDropdown from '../../components/global/dropdown';
import DialogTemplate from '../../components/dialogs/dialogTemplate';

const styles = (theme) => ({
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        borderRadius: 0,
        boxShadow: 'none',
        background: 'transparent',
    },
    fixedHeight: {
        display: 'inline-block',
        textAlign: 'center',
        overflow: 'auto',
        height: '100%',
    },
    fixedPadding: {
        padding: 0,
    },
    multiSelect: {
        width: '120px',
    },
});

export const withAppBarContext = (Element) => {
    // eslint-disable-next-line react/display-name
    return forwardRef((props, ref) => {
        return <AppBarState.Consumer>{(context) => <Element appBarState={context} {...props} ref={ref} />}</AppBarState.Consumer>;
    });
};

class Index extends Component {
    _exporter;
    _timetablesApi = new TimetableApi();
    _termApi = new TermApi();

    defaultDepartment = [];
    defaultSet = [];
    defaultInstructor = [];
    defaultBuilding = [];
    defaultRoom = [];

    _isMounted = false;

    constructor(props) {

        super(props);

        let timetablesToRender = [];

        this.state = {
            terms: [],
            termSelected: null,

            departments: [],
            departmentSelected: this.defaultDepartment,
            allDepartments: [],

            sets: [],
            setsSelected: this.defaultSet,
            allSets: [],

            instructors: [],
            instructorsSelected: this.defaultInstructor,
            allInstructors: [],

            buildings: [],
            buildingSelected: [],
            allBuildings: [],

            rooms: [],
            roomsSelected: this.defaultRoom,
            allRooms: [],

            timetablesToRender: timetablesToRender,

            changesToExportExcel: [],
            view: 12,
            loader: false,

            openDepartmentDialog: false,
            multiplePrintType: '',

            subjects: [],
            printMenu: null,

            isLoading: true,
            openPrintDialog: false,
        };
    }

    export = () => {
        this._exporter.save();
    };

    saveChangesToExport = (classDataToExport) => {
        this.setState({
            changesToExportExcel: [...this.state.changesToExportExcel, classDataToExport],
        });
    };

    async componentDidMount() {
        //TODO: (PS) Load Subjects
        //const subjects = await GetAllSubjects();

        this._isMounted = true;

        const { schoolID, termCampusId, campusId, accountID, viewType, accountType } = this.props;

        //if accountID is defined, then other user data (campusId, schoolId etc.. is also loaded)
        if (accountID) {
            await this.loadData(campusId, schoolID, termCampusId, viewType, accountType);
        }

        // User is coming from the Room Search form
        if (this.props.location && this.props.location.state) {
            let timetablesToRender = [];
            const { room, building } = this.props.location.state;

            timetablesToRender.push({
                settings: { id: room.roomID, roomNumber: room.roomNumber, shouldUpdate: false },
                type: ROOM_TIMETABLE,
            });

            if (this._isMounted) this.setState({ timetablesToRender });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /*
     * New School Or New Term is selected
     * - Get new Departments, Instructors for that school
     * - Reset timetables
     */
    async componentDidUpdate(prevProps) {
        const { schoolID, termSchoolID, termCampusId, appBarState, campusId, viewType, accountType } = this.props;
        const { view } = this.state;

        //If the app bar has been opened or closed. Resize the window to adject the timetables inner item's height / width
        if (appBarState !== prevProps.appBarState) {
            this.handleChangeView(view, 1000);
        }

        //selected school / term / campus is changed
        if (schoolID !== prevProps.schoolID || termSchoolID !== prevProps.termSchoolID || termCampusId !== prevProps.termCampusId || campusId !== prevProps.campusId) {
            await this.loadData(campusId, schoolID, termCampusId, viewType, accountType);
        }
    }

    //terms are only loaded for facilities and central timetabler view type
    async loadData(campusId, schoolID, termCampusId, viewType, accountType) {
        this.setState({ isLoading: true });

        const isCentralTimetablerView = accountType === accountTypes.centralTimetabler || viewType === CENTRAL_TIMETABLER_VIEW_TYPE;

        const terms = isCentralTimetablerView || viewType === FACILITIES_VIEW_TYPE ? await this._termApi.GetTermsByCampusId(campusId) : [];

        const departments = await this._timetablesApi.GetDepartments(viewType === ACADEMIC_VIEW_TYPE ? schoolID : null, isCentralTimetablerView || viewType === FACILITIES_VIEW_TYPE ? campusId : null);
        const buildings = await this._timetablesApi.GetAllBuildings(isCentralTimetablerView || viewType === FACILITIES_VIEW_TYPE && campusId);
        const instructors = await this._timetablesApi.GetInstructors(viewType === ACADEMIC_VIEW_TYPE ? schoolID : null, isCentralTimetablerView || viewType === FACILITIES_VIEW_TYPE ? campusId : null);
        const allInstructors = await this._timetablesApi.GetInstructors();

        const termSelected = terms.find((t) => t.termCampusId === termCampusId);

        const defaultBuilding = viewType === FACILITIES_VIEW_TYPE && buildings?.length === 1 ? buildings[0] : this.defaultBuilding;

        if (viewType === FACILITIES_VIEW_TYPE && !Array.isArray(defaultBuilding)) {
            this.onBuildingSelect(defaultBuilding, buildings);
        }

        this.setState({
            terms,
            termSelected,

            departments,
            allDepartments: departments,
            departmentSelected: this.defaultDepartment,

            sets: [],
            setsSelected: this.defaultSet,

            instructors,
            allInstructors: allInstructors,
            instructorsSelected: this.defaultInstructor,
            buildings,
            allBuildings: buildings,
            buildingSelected: defaultBuilding,

            rooms: [],
            roomsSelected: this.defaultRoom,

            timetablesToRender: [],
            changesToExportExcel: [],
            isLoading: false,
        });
    }

    onTermChange = (name, value) => {
        const termSelected = value;
        const timetablesToRender = this.state.timetablesToRender.map((t) => ({ ...t, settings: { ...t.settings, shouldUpdate: !t.settings.shouldUpdate } }));

        this.setState({ termSelected, timetablesToRender });
    };

    onDepartmentSelect = async (event) => {
        const { departmentSelected, setsSelected, sets, timetablesToRender } = this.state;
        const departments = [...event.target.value];

        let newDepartments = [];
        let allSets = [...sets];

        newDepartments = departments.filter((d) => !departmentSelected.includes(d));

        for (const department of newDepartments) {
            const s = await this._timetablesApi.GetSets(department.departmentID);
            allSets.push(...s);
        }

        this.setState({
            departmentSelected: departments,
            sets: allSets,
            allSets: allSets,
        });
    };

    onDepartmentRemove = (event) => {
        const { departmentSelected, timetablesToRender, sets, setsSelected } = this.state;

        const departments = departmentSelected.filter((d) => d.departmentID !== event.departmentID);
        let allSets = sets.filter((s) => s.programId !== event.departmentID);
        let setsCurrentlySelected = setsSelected.filter((s) => s.programId !== event.departmentID);

        //remove timetables for the set belongs to the removed department
        const renderedTimetables = [...timetablesToRender.filter((t) => t.settings?.departmentCode !== event?.departmentCode)];

        this.setState({
            departmentSelected: departments,
            sets: allSets,
            allSets: allSets,
            setsSelected: setsCurrentlySelected,
            timetablesToRender: renderedTimetables,
        });
    };

    //TODO: SetID's are only unique with in Set's, same for Instructor's and Room's
    onSetSelect = (event) => {
        const { sets, setsSelected } = this.state;

        const setLevels = event.target.value.filter((o) => o.isLevel);
        let value = event.target.value.filter((o) => !o.isLevel);

        if (setLevels && setLevels.length > 0) {
            setLevels.map((o) => {
                const setLevel = sets.filter((p) => p.departmentCode === o.departmentCode && p.level === o.level);
                return setLevel.map((q) => {
                    if (value.findIndex((r) => r.setID === q.setID) === -1) {
                        value.push(q);
                    }
                });
            });
        }

        const newlySelectedSets = [...value];
        let timetablesToRender = [...this.state.timetablesToRender];

        //intersection of all selected vs sets in state
        const newSetTimetableToRender = newlySelectedSets.filter((x) => !setsSelected.includes(x));

        for (const set of newSetTimetableToRender) {
            timetablesToRender.push({
                settings: { id: set.setID, setCode: set.setCode, shouldUpdate: false, isEditable: set.isEditable, departmentCode: set.departmentCode },
                type: SET_TIMETABLE,
            });
        }

        this.setState({ setsSelected: newlySelectedSets, timetablesToRender });
    };

    onSetRemove = (event) => {
        const { setsSelected } = this.state;

        const sets = setsSelected.filter((s) => s.setID !== event.setID);
        let timetablesToRender = this.state.timetablesToRender.filter((t) => t.settings.id !== event.setID);

        this.setState({ setsSelected: sets, timetablesToRender });
    };

    /*
     * Handle Instructor change for Instructor Dropdown
     */
    onInstructorSelect = async (event) => {
        const { termSchoolID } = this.props;

        const setInstructors = event.target.value.filter((o) => o.setID);
        let value = event.target.value.filter((o) => !o.setID);

        if (setInstructors && setInstructors.length > 0) {
            await Promise.all(
                setInstructors.map(async (o) => {
                    const instructorsBySet = await this._timetablesApi.GetInstructorsBySet(termSchoolID, o.setID);
                    return instructorsBySet.map((q) => {
                        if (value.findIndex((r) => r.instructorID === q.instructorID) === -1) {
                            value.push(q);
                        }
                    });
                }),
            );
        }

        const instructorsSelectedAll = [...value];
        let timetablesToRender = [...this.state.timetablesToRender];
        const newInstructorTimetableToRender = instructorsSelectedAll.filter((x) => !this.state.instructorsSelected.includes(x));

        for (const instructor of newInstructorTimetableToRender) {
            timetablesToRender.push({
                settings: { id: instructor.instructorID, name: instructor.fullName, shouldUpdate: false },
                type: INSTRUCTOR_TIMETABLE,
            });
        }

        this.setState({
            instructorsSelected: instructorsSelectedAll,
            timetablesToRender,
        });
    };

    onInstructorRemove = (event) => {
        const { instructorsSelected } = this.state;

        const instructors = instructorsSelected.filter((i) => i.instructorID !== event.instructorID);

        let timetablesToRender = this.state.timetablesToRender.filter((t) => t.settings.id !== event.instructorID);

        this.setState({
            instructorsSelected: instructors,
            timetablesToRender,
        });
    };

    /*
     * Change the selected Building
     */
    onBuildingSelect = async (event, buildings) => {
        const { viewType } = this.props;
        let buildingSelected = null;
        let timetablesToRender = [...this.state.timetablesToRender];

        let newBuildings = [];
        let rooms = [];

        if (viewType === FACILITIES_VIEW_TYPE && buildings?.length === 1) {
            buildingSelected = event;
            const r = await this._timetablesApi.GetRooms(event.buildingID);
            const room = r.map((obj) => ({ ...obj, building: buildingSelected }));
            rooms = [...this.state.rooms, ...room];
        } else {
            buildingSelected = [...event.target.value];
            newBuildings = buildingSelected.filter((b) => !this.state.buildingSelected.includes(b));
            for (const building of newBuildings) {
                const r = await this._timetablesApi.GetRooms(building.buildingID);
                const room = r.map((obj) => ({ ...obj, building: building }));
                rooms = [...this.state.rooms, ...room];
            }
        }

        this.setState({
            buildingSelected,
            rooms,
            allRooms: rooms,
            timetablesToRender,
        });
    };

    onBuildingRemove = (event) => {
        const { buildingSelected, timetablesToRender } = this.state;

        const buildings = buildingSelected.filter((b) => b.buildingID !== event.buildingID);
        let rooms = this.state.rooms.filter((r) => r.buildingID !== event.buildingID);
        let roomsSelected = this.state.roomsSelected.filter((r) => r.buildingID !== event.buildingID);

        const renderedTimetables = [...timetablesToRender.filter((t) => t.settings?.buildingCode !== event?.buildingCode)];

        this.setState({
            buildingSelected: buildings,
            rooms,
            allRooms: rooms,
            roomsSelected,
            timetablesToRender: renderedTimetables,
        });
    };

    onRoomSelect = (event) => {
        const roomsSelectedAll = [...event.target.value];
        let timetablesToRender = [...this.state.timetablesToRender];

        const newRoomToRender = roomsSelectedAll.filter((r) => !this.state.roomsSelected.includes(r));

        for (const room of newRoomToRender) {
            timetablesToRender.push({
                settings: { id: room.roomID, roomNumber: room.roomNumber, shouldUpdate: false, buildingCode: room.building.buildingCode },
                type: ROOM_TIMETABLE,
            });
        }

        this.setState({
            roomsSelected: roomsSelectedAll,
            timetablesToRender,
        });
    };

    onRoomRemove = (event) => {
        const roomsSelected = this.state.roomsSelected.filter((r) => r.roomID !== event.roomID);
        const timetablesToRender = this.state.timetablesToRender.filter((t) => t.settings.id !== event.roomID);

        this.setState({
            roomsSelected,
            timetablesToRender,
        });
    };

    splitDataIntoTwoColumnLayout = (timetablesToRender) => {
        let gridMapping = [];

        for (let i = 0; i < timetablesToRender.length; i = i + 2) {
            const start = i;
            const end = i + 2;
            gridMapping.push(_.slice(timetablesToRender, start, end));
        }

        return gridMapping;
    };

    handleChangeView = (value, ms = 1) => {
        this.setState({ view: value });

        // Trigger window resize manually to fix view toggle bug
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, ms);
    };

    printMultipleTimetables = (type) => {
        this.setState({ openPrintDialog: true, multiplePrintType: type, printMenu: null });
    };

    cancelPrint = () => {
        this.setState({ openPrintDialog: false });
    };

    printMultiple = async (ids) => {
        debugger;
        const { termSchoolID } = this.props;
        const { multiplePrintType } = this.state;

        if (multiplePrintType === 'set') {
            toast.info('Printing Set Reports');
            await exportMultipleSetReport(termSchoolID, 0, ids); //week: 0
        } else if (multiplePrintType === 'instructor') {
            toast.info('Printing Instructor Reports');
            await exportMultipleInstructorReport(termSchoolID, 0, ids); //week: 0
        } else if (multiplePrintType === 'room') {
            toast.info('Printing Room Reports');
            await exportMultipleRoomReport(termSchoolID, 0, ids); //week: 0
        }

        this.setState({ openPrintDialog: false });
    };

    printAll = async (departmentID) => {
        const { termSchoolID } = this.props;
        const { multiplePrintType } = this.state;

        if (multiplePrintType === 'set') {
            toast.info('Printing Set Reports');
            await exportDepartmentSetReport(termSchoolID, 0, departmentID); //week: 0
        } else if (multiplePrintType === 'instructor') {
            toast.info('Printing Instructor Reports');
            await exportDepartmentInstructorReport(termSchoolID, 0, departmentID); //week: 0
        }

        this.setState({ openPrintDialog: false });
    };

    handleClickThrough = async ({ remove, add }) => {
        const timetablesToRender = this.state.timetablesToRender;
        const timetableToRemoveIndex = timetablesToRender.findIndex((t) => t.type === remove.timetableType && t.settings.id === remove.id);

        let { departments, departmentSelected, sets, setsSelected, instructors, allInstructors, instructorsSelected, buildings, buildingSelected, rooms, roomsSelected } = this.state;

        switch (remove.timetableType) {
            case INSTRUCTOR_TIMETABLE:
                instructorsSelected = instructorsSelected.filter((o) => o.instructorID !== remove.id);
                break;

            case SET_TIMETABLE: {
                // Find set in selected sets to retrieve department code
                const setToRemove = setsSelected.find((o) => o.setID === remove.id);

                if (setToRemove) {
                    // Filter out set to remove from selected sets
                    const newSelectedSets = setsSelected.filter((o) => o.setID !== remove.id);

                    // Check if there is another set from the same department selected
                    // If yes leave department in selection, if not then remove
                    const newSelectedDepartments =
                        newSelectedSets.length > 0 && newSelectedSets.find((o) => o.departmentCode === setToRemove.departmentCode)
                            ? departmentSelected
                            : departmentSelected.filter((o) => o.departmentCode !== setToRemove.departmentCode);

                    // this.setState({ setsSelected: newSelectedSets, departmentSelected: newSelectedDepartments });
                    setsSelected = newSelectedSets;
                    departmentSelected = newSelectedDepartments;
                }

                break;
            }
            case ROOM_TIMETABLE: {
                // Find room in selected rooms to retrieve building code
                const roomToRemove = roomsSelected.find((o) => o.roomID === remove.id);

                if (roomToRemove) {
                    // Filter out room to remove from selected rooms
                    const newSelectedRooms = roomsSelected.filter((o) => o.roomID !== remove.id);

                    // Check if there is another room from the same building selected
                    // If yes leave building in selection, if not then remove
                    const newSelectedBuildings =
                        newSelectedRooms.length > 0 && newSelectedRooms.find((o) => o.buildingID === roomToRemove.buildingID)
                            ? buildingSelected
                            : buildingSelected.filter((o) => o.buildingID !== roomToRemove.buildingID);

                    roomsSelected = newSelectedRooms;
                    buildingSelected = newSelectedBuildings;
                }
                break;
            }
            // eslint-disable-next-line no-empty
            default: {
            }
        }

        switch (add.timetableType) {
            case SET_TIMETABLE: {
                const department = departments.find((o) => o.departmentCode === add.departmentCode);
                if (department) {
                    const newSets = await this._timetablesApi.GetSets(department.departmentID);

                    const newSetSelected = newSets.find((o) => o.setID === add.id);

                    if (newSetSelected && timetableToRemoveIndex !== -1) {
                        timetablesToRender[timetableToRemoveIndex] = {
                            settings: { id: add.id, setCode: add.setCode, shouldUpdate: true },
                            type: SET_TIMETABLE,
                        };

                        departmentSelected = _.unionBy(departmentSelected, [department], 'departmentCode');
                        sets = _.unionBy(newSets, 'setID');
                        setsSelected = _.unionBy(setsSelected, [newSetSelected], 'setID');
                    }
                }
                break;
            }
            case INSTRUCTOR_TIMETABLE: {
                const newInstructor = allInstructors.find((o) => o.instructorID === add.id);

                if (newInstructor && timetableToRemoveIndex !== -1) {
                    timetablesToRender[timetableToRemoveIndex] = {
                        settings: { id: add.id, name: add.name, shouldUpdate: true },
                        type: INSTRUCTOR_TIMETABLE,
                    };

                    instructorsSelected = _.unionBy(instructorsSelected, [{ ...newInstructor, name: add.name }], 'instructorID');
                }
                break;
            }
            case ROOM_TIMETABLE: {
                const building = buildings.find((o) => o.buildingCode === add.buildingCode);

                if (building) {
                    const newRooms = await this._timetablesApi.GetRooms(building.buildingID);
                    const newRoomSelected = newRooms.find((o) => o.roomID === add.id);

                    if (newRoomSelected && timetableToRemoveIndex !== -1) {
                        timetablesToRender[timetableToRemoveIndex] = {
                            settings: { id: add.id, roomNumber: add.roomNumber, shouldUpdate: true, buildingCode: add.buildingCode },
                            type: ROOM_TIMETABLE,
                        };

                        buildingSelected = _.unionBy(buildingSelected, [building], 'buildingCode');
                        rooms = _.unionBy(
                            newRooms.map((room) => ({ ...room, building: { buildingCode: add.buildingCode } })),
                            'roomID',
                        );
                        roomsSelected = _.unionBy(roomsSelected, [{ ...newRoomSelected, building: { buildingCode: add.buildingCode } }], 'roomID');
                    }
                }

                break;
            }
            // eslint-disable-next-line no-empty
            default: {
            }
        }

        this.setState({
            departmentSelected,
            sets,
            setsSelected,

            buildingSelected,
            rooms,
            roomsSelected,

            instructorsSelected,

            timetablesToRender,
        });
    };

    render() {
        const {
            terms,
            termSelected,
            departments,
            departmentSelected,
            sets,
            setsSelected,
            instructors,
            instructorsSelected,
            buildings,
            buildingSelected,
            rooms,
            roomsSelected,
            timetablesToRender,
            changesToExportExcel,
            view,
            multiplePrintType,
            subjects,
            isLoading,
            openPrintDialog,
        } = this.state;


        const { classes, schoolID, termSchoolID, accountID, termCode, firstName, lastName, accountType, viewType, campusId, termSchools } = this.props;

        const isCentralTimetablerView = accountType === accountTypes.centralTimetabler || viewType === CENTRAL_TIMETABLER_VIEW_TYPE;


        // TODO: termCampusId is null when no term is selected (facilities view), related to above
        let termCampusId = this.props.termCampusId;

        if (termSelected) {
            termCampusId = termSelected.termCampusId;
        }

        //render empty timetable on first load
        const gridData = this.splitDataIntoTwoColumnLayout(
            timetablesToRender.length === 0
                ? [
                      {
                          settings: {},
                          type: '',
                      },
                  ]
                : timetablesToRender,
        );

        // Filter out all possible set level values
        const setLevels = sets
            .map((o) => {
                return {
                    setID: `${o.departmentCode}-${o.level}`,
                    setCode: `${o.departmentCode} - Level ${o.level}`,
                    departmentCode: o.departmentCode,
                    level: o.level,
                    isLevel: true,
                };
            })
            .filter((o, index, self) => self.findIndex((p) => p.departmentCode === o.departmentCode && p.level === o.level) === index);

        // -------------- Allow the admin to select all instructor for a set -->  Creates bugs and is NOT functional in the old portal as well. TBD.
        // const instructorsBySet = setsSelected.map((o) => {
        //     return { ...o, instructorID: o.setCode, name: `Set ${o.setCode} Instructors` };
        // });
        // -----------------

        const disabledState = viewType === FACILITIES_VIEW_TYPE && buildings?.length === 1;

        const setDisabled = (arr, compareArray) => {
            let array = arr;
            if (!Array.isArray(arr)) {
                array = [arr];
            }
            let disabledState = false;
            if (viewType === FACILITIES_VIEW_TYPE) {
                if (array?.length <= 1) disabledState = true;
                if (!termSelected) return true;
            }

            if (compareArray) {
                disabledState = compareArray?.length === 0;
            }

            return disabledState;
        };

        const getProgramDisplayValue = (program) => {
            return `${program.departmentCode} - ${program.departmentName}`;
        };

        const getRoomDropownDisplayValue = (room) => {
            if (viewType === ACADEMIC_VIEW_TYPE) return `${room.building.buildingCode} - ${room.roomNumber}`;
            else return `${room.roomNumber}`;
        };

        return (
            <>
                <Header>
                    <HeaderSection style={{ flex: 5, marginRight: '10px' }}>
                        {(isCentralTimetablerView || viewType === FACILITIES_VIEW_TYPE) && (
                            <>
                                <Label>Term</Label>
                                <HeaderRow>
                                    <HeaderItem>
                                        <GlobalDropdown
                                            isSearch
                                            data={terms}
                                            value={termSelected}
                                            name={'termCode'}
                                            field={'termCampusId'}
                                            placeholder={'Select a term'}
                                            sx={{ flex: 1 }}
                                            onChange={this.onTermChange}
                                            disabled={terms?.length === 0}
                                        />
                                    </HeaderItem>
                                </HeaderRow>
                            </>
                        )}
                        <Label>Program</Label>
                        <HeaderRow>
                            <HeaderItem style={{ marginRight: '10px' }}>
                                <GlobalDropdown
                                    isSearch
                                    multiSelect
                                    data={departments}
                                    value={departmentSelected}
                                    name={'departmentCode'}
                                    field={'departmentID'}
                                    placeholder={'Select program(s)'}
                                    sx={{ flex: 2 }}
                                    onChange={this.onDepartmentSelect}
                                    handleRemove={this.onDepartmentRemove}
                                    disabled={setDisabled(departments)}
                                    isRenderData={true}
                                    renderData={getProgramDisplayValue}
                                />
                            </HeaderItem>
                            <HeaderItem>
                                <GlobalDropdown
                                    isSearch
                                    multiSelect
                                    data={[...setLevels, ...sets]}
                                    value={setsSelected}
                                    name={'setCode'}
                                    field={'setID'}
                                    placeholder={'Select set(s)'}
                                    sx={{ flex: 2 }}
                                    onChange={this.onSetSelect}
                                    handleRemove={this.onSetRemove}
                                    disabled={setDisabled([...setLevels, ...sets], departmentSelected)}
                                />
                            </HeaderItem>
                        </HeaderRow>

                        <Label>Instructor</Label>
                        <HeaderRow>
                            <HeaderItem>
                                <GlobalDropdown
                                    isSearch
                                    multiSelect
                                    data={[...instructors]}
                                    value={instructorsSelected}
                                    name={'fullName'}
                                    field={'instructorID'}
                                    placeholder={'Select instructor(s)'}
                                    sx={{ flex: 1 }}
                                    onChange={this.onInstructorSelect}
                                    handleRemove={this.onInstructorRemove}
                                    disabled={setDisabled([...instructors])}
                                />
                            </HeaderItem>
                        </HeaderRow>

                        <Label>Location</Label>
                        <HeaderRow>
                            <HeaderItem style={{ marginRight: '10px' }}>
                                <GlobalDropdown
                                    isSearch
                                    multiSelect={!disabledState}
                                    data={buildings}
                                    value={buildingSelected}
                                    name={'buildingCode'}
                                    field={'buildingID'}
                                    placeholder={'Select building(s)'}
                                    sx={{ flex: 1 }}
                                    onChange={this.onBuildingSelect}
                                    handleRemove={this.onBuildingRemove}
                                    disabled={setDisabled(buildings)}
                                />
                            </HeaderItem>
                            <HeaderItem longer={true}>
                                <GlobalDropdown
                                    isSearch
                                    multiSelect
                                    data={rooms}
                                    value={roomsSelected}
                                    name={'roomNumber'}
                                    field={'roomID'}
                                    placeholder={'Select room(s)'}
                                    sx={{ flex: 3 }}
                                    onChange={this.onRoomSelect}
                                    handleRemove={this.onRoomRemove}
                                    disabled={setDisabled(buildingSelected, rooms)}
                                    isRenderData={viewType === FACILITIES_VIEW_TYPE ? false : true}
                                    renderData={getRoomDropownDisplayValue}
                                    isRenderValue
                                    renderValue={getRoomDropownDisplayValue}
                                    searchField={'building'}
                                    additionalSearchField={'buildingCode'}
                                    isManualClose={true}
                                />
                            </HeaderItem>
                        </HeaderRow>
                    </HeaderSection>
                    <HeaderSection style={{ flex: 0.75, display: 'flex', position: 'relative' }}>
                        <WidgetContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <WidgetLabel>Timetable View Option</WidgetLabel>
                            <Button
                                style={{
                                    background: this.state.view === 12 ? 'rgba(0, 124, 222, 0.1)' : 'transparent',
                                    color: this.state.view === 12 ? colors.blue.main : 'rgba(84, 84, 84, 0.5)',
                                    border: `1px solid ${colors.blue.main}`,
                                    borderRadius: '3px',
                                    width: '94px',
                                    marginBottom: '10px',
                                }}
                                onClick={() => this.handleChangeView(12)}
                                text="FULLVIEW"
                                startIcon={
                                    <WidgetSwitch
                                        style={{
                                            border: `1px solid ${this.state.view === 12 ? colors.blue.main : 'rgba(84, 84, 84, 0.5)'}`,
                                        }}
                                    />
                                }
                            />
                            <Button
                                style={{
                                    background: this.state.view === 6 ? 'rgba(0, 124, 222, 0.1)' : 'transparent',
                                    color: this.state.view === 6 ? colors.blue.main : 'rgba(84, 84, 84, 0.5)',
                                    border: `1px solid ${colors.blue.main}`,
                                    borderRadius: '3px',
                                    width: '94px',
                                }}
                                onClick={() => this.handleChangeView(6)}
                                text="HALFVIEW"
                                startIcon={
                                    <WidgetSwitch
                                        style={{
                                            border: `1px solid ${this.state.view === 6 ? colors.blue.main : 'rgba(84, 84, 84, 0.5)'}`,
                                        }}
                                    />
                                }
                            />
                        </WidgetContainer>
                    </HeaderSection>
                </Header>

                {timetablesToRender.length > 0 && (
                    <Fragment>
                        <Grid container>
                            {gridData.map((grid, outerArrIndex) => (
                                <Fragment key={outerArrIndex.toString()}>
                                    {grid.map((timetable, innerArrIndex) => (
                                        <StyledGrid xs={view} key={timetable.type + timetable.settings.id.toString()}>
                                            <Timetable
                                                viewType={viewType}
                                                key={timetable.type + timetable.settings.id.toString() + innerArrIndex.toString()}
                                                settings={timetable.settings}
                                                type={timetable.type}
                                                schoolID={schoolID}
                                                termSchoolID={termSchoolID}
                                                termCampusId={termCampusId}
                                                saveChangesToExport={this.saveChangesToExport}
                                                accountID={accountID}
                                                termCode={termCode}
                                                shouldUpdate={timetable.settings.shouldUpdate}
                                                firstName={firstName}
                                                lastName={lastName}
                                                onClickThrough={this.handleClickThrough}
                                                sets={sets}
                                                termSelected={termSelected}
                                            />
                                        </StyledGrid>
                                    ))}
                                </Fragment>
                            ))}
                        </Grid>
                    </Fragment>
                )}

                <ExcelExport
                    data={changesToExportExcel}
                    fileName={moment().format(MOMENT_DATE_FORMAT) + ' ' + moment().format(MOMENT_TIME_DISPLAY_FORMAT)}
                    ref={(exporter) => {
                        this._exporter = exporter;
                    }}
                >
                    <ExcelExportColumn field="term" title="Term" width={70} />
                    <ExcelExportColumn field="change" title="Change" width={70} />
                    <ExcelExportColumn field="action" title="Action" width={70} />
                    <ExcelExportColumn field="crn" title="CRN" width={70} />
                    <ExcelExportColumn field="course" title="Course" width={70} />
                    <ExcelExportColumn field="block" title="Block" width={70} />
                    <ExcelExportColumn field="type" title="Type" width={70} />
                    <ExcelExportColumn field="fromDay" title="From Day" width={70} />
                    <ExcelExportColumn field="fromTime" title="From Time" width={70} />
                    <ExcelExportColumn field="fromRoom" title="From Room" width={70} />
                    <ExcelExportColumn field="toDay" title="To Day" width={70} />
                    <ExcelExportColumn field="toTime" title="To Time" width={70} />
                    <ExcelExportColumn field="toRoom" title="To Room" width={70} />
                    <ExcelExportColumn field="from" title="From" width={110} />
                    <ExcelExportColumn field="to" title="To" width={110} />
                    <ExcelExportColumn field="bannerID" title="Banner ID" width={70} />
                    <ExcelExportColumn field="comments" title="Comments" width={400} />
                </ExcelExport>

                {openPrintDialog && (
                    <PrintMultipleReports
                        open={openPrintDialog}
                        cancelPrint={this.cancelPrint}
                        departments={departments}
                        multiplePrintType={multiplePrintType}
                        buildings={buildings}
                        instructors={instructors}
                        subjects={subjects}
                        printMultiple={this.printMultiple}
                        printAll={this.printAll}
                    />
                )}

                {this.state.loader && (
                    <Loader>
                        <CircularProgress />
                    </Loader>
                )}

                {isLoading && (
                    <DialogTemplate
                        title={'Loading data...'}
                        disableClose={true}
                        renderContent={() => {
                            return (
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', margin: '1em 0' }}>
                                    <CircularProgress size={100} />
                                </Box>
                            );
                        }}
                    />
                )}
            </>
        );
    }
}

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;
    z-index: 5;
`;

const HeaderSection = styled.div`
    padding: 8px;
    z-index: 5;
    background: white;
    border-radius: 5px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 5px;
`;

const HeaderItem = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex: ${(props) => (props.longer ? 2 : 1)};

    .k-input,
    .k-chip {
        font-family: Roboto !important;
    }

    .k-chip {
        font-size: 10px;
    }

    .k-floating-label-container {
        width: 100%;
    }

    .k-icon.k-i-loading {
        display: none !important;
    }

    .k-widget {
        width: 100% !important;
        background: transparent;
    }

    .k-input-values.k-selection-multiple {
        padding: 0;
    }

    .k-input.k-focus {
        box-shadow: none;
    }

    .k-multiselect {
        flex: 1;
        width: 100%;
        cursor: pointer;
    }

    .k-multiselect.k-input {
        background-color: transparent !important;
        border-width: 1px;
        border-color: rgba(84, 84, 84, 0.2);
        border-radius: 5px;
        padding: 0 2px;
        font-size: 12px;

        &:hover {
            border-color: ${colors.blue.main} !important;
        }

        li > .k-list-item:hover {
            background: ${colors.blue.light};
            border-radius: 5px;
        }

        .k-list-item.k-selected:hover {
            background-color: ${colors.blue.light} !important;
        }
    }

    .k-dropdown .k-dropdown-wrap .k-input,
    .k-multiselect .k-multiselect-wrap .k-button,
    .k-label {
        color: ${colors.blue.main} !important;

        .k-chip-solid-base {
            background: ${colors.blue.main};
            color: white;
            border-radius: 15px;

            .k-chip-icon {
                color: white;
            }
        }
    }
`;

const WidgetContainer = styled.div`
    flex: 1;
    text-align: center;
`;

const WidgetLabel = styled.div`
    font-weight: bold;
    font-size: 12px;
    text-align: center;
    margin-bottom: 1em;
`;

const WidgetSwitch = styled.div`
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 100%;
`;

const Loader = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledGrid = styled(Grid)`
    && {
        background-color: ${colors.white};
        padding: 5px;
        border-radius: 5px;
    }
`;

const Label = styled.div`
    color: #0085e6;
    font-size: 12px;
    font-weight: 700;

    & > span {
        color: #d73948;
    }
`;

const mapStateToProps = function (state) {
    return {
        schoolID: state.appState.school?.id,
        termSchoolID: state.appState.term?.termSchoolId,
        termCampusId: state.appState.term?.termCampusId,
        termCode: state.appState.term?.termCode,
        accountID: state.user.id,
        campusId: state.appState.campus?.id,
        firstName: state.user.firstName,
        lastName: state.user.lastName,
        accountType: state.user.accountType,
        viewType: state.appState.viewType,
        termSchools: state.appState.termSchools,
    };
};

export default withAppBarContext(connect(mapStateToProps)(Index));
